module.exports = __webpack_public_path__ + "media/images/count-box-bg-blue-4941fde2.svg";